import React from 'react';
import './Section.sass';
import data from '../../data';

const Section = ({slideData, index}) => {

  const {caption, slogan, text, images, footer} = slideData;
  return (
    <div className={`section section--${index}`}>
      { caption && index === 1 && <div className="section__separator-wrap"><h2 className="section__separator">
        { caption.split(' ')[0]}
        <span>&nbsp;</span>
        <br className="section__break"/>
        { caption.split(' ')[1]}
      </h2></div> }
      <div className="section__body">
        <div className="section__title">
          { caption && <h2 className="section__caption">{ caption }</h2> }
          <h6 className="section__slogan" dangerouslySetInnerHTML={{__html: slogan}}></h6>
          <p className="section__text" dangerouslySetInnerHTML={{__html: text}}></p>
        </div>
        <div className="section__image">
          <picture>
            <source srcSet={images.mobile[0]} srcSet={images.mobile[1]} media="(max-width: 498px)"/>
            <img src={images.desktop[0]} srcSet={images.desktop[1]} alt="ВКонтакте"/>
          </picture>
        </div>

      </div>
      {
        footer && (
          <div className="section__footer">
            <div className="section__title">
              <h6 className="section__slogan" dangerouslySetInnerHTML={{__html: footer.slogan}}></h6>
              <p className="section__info">
                <span className="section__text" dangerouslySetInnerHTML={{__html: footer.text}}></span>
                &nbsp;
                <a
                  href={`https://m.${data.hostName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="section_shot-addr"
                >m.{data.hostName}.</a>
              </p>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default Section;
